import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEntryProps } from "components/change-entry/types";
import { ChangeType } from "enums";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./ChangeEntry.css";

const mapStateToProps = (state:AppState):ChangeEntryProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class ChangeLogEntry extends Component<ChangeEntryProps.Component> {
	render():JSX.Element{
		const typeClass = Object.keys(ChangeType)[Object.values(ChangeType).indexOf(this.props.type)];
		return (
			<li>
				<div className="change-log-entry">
					<div>
						<FontAwesomeIcon icon={faAngleRight} />
						<span className={typeClass}>{t.t(this.props.type)}</span>
					</div>
					<div>
						<p>{this.props.entry}</p>
					</div>
				</div>
			</li>
		);
	}
}
export default connect(mapStateToProps)(ChangeLogEntry);
